
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 100 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M91.167 12v28.5a3.167 3.167 0 01-6.334 0V19.645L60.24 44.239a3.167 3.167 0 01-4.478-4.478l24.594-24.594H59.5a3.167 3.167 0 110-6.334H88A3.167 3.167 0 0191.167 12zM8.833 88V59.5a3.167 3.167 0 116.334 0v20.855L39.76 55.761a3.167 3.167 0 014.478 4.478L19.645 84.833H40.5a3.167 3.167 0 010 6.334H12A3.167 3.167 0 018.833 88z","fill":"#fff"}})])
          )
        }
      }
    